import { userApi } from "../api/api"
import { simpleGetter } from "./common"
import { accessGlobalUserState } from "../stores/user"

const signIn = async (login, password) => {
    const data = {}
    const response = await simpleGetter(userApi.signIn, {
        login,
        password
    })
    if(response.token) {
        accessGlobalUserState().set(response)
        data.success = true
    } else {
        data.success = false
    }
    return data
}

export const authActions = {
    signIn
}